export default __webpack_public_path__ + "static/media/grandPlace1a.1d6f3aa0.jpg";